import { AllowanceCharge } from '../../data/models'
import i18n from '../../utils/i18n'

export const AlcTypeBodyTemplate = (alcType: AllowanceCharge['AlcType']) => {
  if (!alcType) return null

  const translation =
    alcType === 'Surcharge'
      ? i18n.t('common.codes.alcType.surcharge')
      : i18n.t('common.codes.alcType.discount')

  return <>{translation}</>
}
